export enum ReplayOperation {
  UNDO = "undo",
  REDO = "redo",
}
